import { Divider } from "@msuite/ui/divider";
import { useDisclosure } from "@msuite/ui/hooks";
import { PlanStateTag } from "@msuite/ui/tag";
import { TimelineItem } from "@msuite/ui/timeline";
import type { ProjectTimelineAssignment } from "@msuite/utils/types";
import { OrganizationCard } from "@/components/cards";
import { TicketTypeIcon } from "@/components/cards/ticket-card";
import { NoteHintButton } from "@/components/notes";
import { ProjectTimelineItemNotes } from "./project-timeline-item-notes";

/** Props Interface */
interface ProjectTimelineAssignmentItemProps {
	item: ProjectTimelineAssignment;
}

export function ProjectTimelineAssignmentItem({ item }: ProjectTimelineAssignmentItemProps) {
	/** Hooks */
	const notesDisclosure = useDisclosure();

	/** Render */
	return (
		<div className="v-stack">
			<TimelineItem state={item.crew.plan.state}>
				<div className="flex flex-row justify-between col-span-2">
					<OrganizationCard
						orgId={item.crew.orgId}
						suffix={item.crew.ranking}
						variant="plain"
						fontWeight="semibold"
					/>
					<PlanStateTag state={item.crew.plan.state} />
				</div>
				<Divider
					variant="card"
					className="col-span-2"
				/>
				<TicketTypeIcon ticketTypeId={item.ticket.type} />
				<div className="justify-between h-stack items-baseline">
					<div className="max-w-[80%]">
						<p>{item.ticket.description}</p>
					</div>
					<div className="w-max whitespace-nowrap">
						<p className="label">{item.ticket.number}</p>
					</div>
				</div>
				<Divider
					className="col-span-2"
					variant="card"
				/>
				<div className="h-stack col-span-2 justify-end">
					<NoteHintButton
						disclosure={notesDisclosure}
						notesTable="ticketAssignmentNotes"
						identifier={item.id}
					/>
				</div>
			</TimelineItem>
			<ProjectTimelineItemNotes
				notesTable="ticketAssignmentNotes"
				identifier={item.id}
				disclosure={notesDisclosure}
			/>
		</div>
	);
}
